import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "absolute-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_spinner = _resolveComponent("q-spinner");
    const _component_router_view = _resolveComponent("router-view");
    return (_openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                fallback: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_q_spinner, {
                            color: "light-green",
                            size: "12em",
                            thickness: 8
                        })
                    ])
                ]),
                _: 2
            }, 1024))
        ]),
        _: 1
    }));
}
